import wx from 'weixin-js-sdk';

export default function wxShare(res) {
  const shareDetail = res;
  const shareData = {
    title: shareDetail.title,
    link: shareDetail.url,
    imgUrl: shareDetail.logoUrl, // 分享图标
    desc: shareDetail.content, // 分享描述
    success: () => {
      this.showShareResult('分享成功');
    },
    cancel: () => {
      this.showShareResult('分享取消');
    },
    error: (error) => {
      this.showShareResult(error);
    },
  };
  wx.ready(() => {
    wx.onMenuShareAppMessage(shareData);
    wx.onMenuShareTimeline(shareData);
  });
}